import {useState} from "#app";
import {onMounted, watch} from "vue";

export default function useStateAccommodationList() {

    const selectedMapItem = useState<null | number>('acc-list-selected-map-item', () => null);
    const filterData = useState<{ [k: string]: any }>('default-map-filter-data', () => {
        return {}
    });

    const setLastFilterData = (params) => {
        selectedMapItem.value = params;
    }

    const updateFilterData = (params: { [k: string]: any }) => {
        filterData.value = {...filterData.value, ...params};
    }

    watch(filterData, (val) => {
        if (process.client) {
            localStorage.setItem('filter-data', JSON.stringify(val));
        }
    })

    onMounted(() => {
        try {
            filterData.value = JSON.parse(localStorage.getItem('filter-data'));
        } catch (e) {
            // Nothing
        }
    })

    return {selectedMapItem, filterData, setLastFilterData, updateFilterData}
}
